import { Component, OnInit, Input } from "@angular/core";
import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";
import { OwlOptions } from "ngx-owl-carousel-o";

@Component({
    selector: "app-carousel",
    templateUrl: "./carousel.component.html",
    styleUrls: ["./carousel.component.scss"],
    standalone: false
})
export class CarouselComponent implements OnInit {
  constructor(
    private canvasService: CanvasService,
    public commonService: CommonService
  ) {}
  @Input() canvas_listing: any;
  @Input() showCarousel: boolean = false;
  @Input() canvasType: any;

  public customOptions: OwlOptions = {
    items: 0,
    loop: false,
    margin: 10,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    slideBy: 4,
    dots: false,
    lazyLoad: true,
    navSpeed: 700,
    nav: true,
    skip_validateItems: true,
    navText: [
      '<img src="/assets/images/carousel/prev.png" alt="previous" width="40px" height="41px">',
      '<img src="/assets/images/carousel/next.png" alt="next" width="40px" height="41px">',
    ],
    responsive: {
      400: {
        items: 2,
      },
      600: {
        items: 3,
      },
      900: {
        items: 4,
      },
    },
  };

  ngOnInit(): void {}
}
